import ManageLayout from "../../components/ManageLayout";
import Tbl from "../../../input_types/Tbl/Tbl";

export default function Products(){
    return <ManageLayout>
            <div>
                <h1>manage products</h1>
                <Tbl
                    tblName={"pdts"}
                    listFlds={"sn,name,brandAbbr,description,wwCategory,images"}
                    btns={{
                        edit: 'stdEdit'
                    }}
                ></Tbl>
            </div>;        
        </ManageLayout>

}